import { render, staticRenderFns } from "./CabinSetup.vue?vue&type=template&id=666e0123&scoped=true"
import script from "./CabinSetup.vue?vue&type=script&lang=js"
export * from "./CabinSetup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666e0123",
  null
  
)

export default component.exports